<template>
	 <div class="main main-really-raised w-50 ml-auto mr-auto">
    <div class="container">
      <div class="row">
        <div class="col-12">
									<div class="controls-header d-flex justify-content-between">
									<h4 class="card-title mb-3">
												{{ $t("message.contracts."+document_type) }}
										</h4>
										<div class="btns d-flex" style="gap: 10px">
											<button class="btn btn-sm btn-outline-secondary" @click.prevent="backToContractDocs()"><i class="el-icon-arrow-left"></i> Back</button>
											<button type="button" class="btn btn-sm btn-outline-secondary"><i class="el-icon-download"></i> Export XML</button>
											<js-pdf :pageMarginsInPx="[30, 30, 30, 30]" :pageFullWidthInPx="1400" :filename="'form_m_' + document_id + '.pdf'">
												<template v-slot="pdfProps">
													<pdf-form-m :pdfProps="pdfProps" :documentId="document_id"/>
												</template>
											</js-pdf>
									</div>
								</div>
          <div :class="document_type == 'form_m'?'no-shadow mt-0':'card no-shadow mt-0'">
													<div :class="document_type == 'form_m'?'':'card-body mt-3'">
														<form-m v-if="document_type == 'form_m'" 
														:contract_details="contract_details"
														:document_id="document_id"
														:is_new="document_id=='new'"
														:document_parent="document_parent"
														:document="{}"
														/>
														<form-invoice
															v-if="document_type == 'invoice'"
															:goods="goods"
															:contract_details="contract_details"
															:document_id="document_id"
															:document="{}"
														></form-invoice>
														<form-cmr
															v-if="
																	document_type == 'cmr'
															"
															:goods="goods"
															:contract_details="contract_details"
															:document_id="document_id"
															:document="{}"
													></form-cmr>
													<form-fm1
															v-if="
																	document_type == 'fm1'
															"
															:goods="goods"
															:contract_details="contract_details"
															:document_id="document_id"
															:document="{}"
													></form-fm1>
													<form-epi
															v-if="
																	document_type == 'epi'
															"
															:goods="goods"
															:contract_details="contract_details"
															:document_id="document_id"
															:document="{}"
													></form-epi>
													<form-awb
															v-if="
																	document_type == 'awb'
															"
															:goods="goods"
															:contract_details="contract_details"
															:document_id="document_id"
															:document="{}"
													></form-awb>
													<form-rwb
															v-if="
																	document_type == 'rwb'
															"
															:goods="goods"
															:contract_details="contract_details"
															:document_id="document_id"
															:document="{}"
													></form-rwb>
													<form-insurance
															v-if="
																	document_type == 'insurance'
															"
															:goods="goods"
															:contract_details="contract_details"
															:document_id="document_id"
															:document="{}"
													></form-insurance>
													<form-liability-insurance
															v-if="
																	document_type == 'liability-insurance'
															"
															:goods="goods"
															:contract_details="contract_details"
															:document_id="document_id"
															:document="{}"
													></form-liability-insurance>
													<form-packaging
															v-if="
																	document_type == 'packaging'
															"
															:goods="goods"
															:contract_details="contract_details"
															:document_id="document_id"
															:document="{}"
													></form-packaging>

													<form-sad
															:files="files"
															v-if="
																	document_type == 'sad'
															"
															:goods="goods"
															:contract_details="contract_details"
															:document_id="document_id"
															:document="{}"
													></form-sad>
													<form-ktg-attorney
															v-if="
																	document_type == 'ktg_attorney'
															"
															:goods="goods"
															:contract_details="contract_details"
															:document_id="document_id"
															:document="{}"
													></form-ktg-attorney>

													<form-specification
															v-if="
																	document_type == 'specification'
															"
															:goods="goods"
															:contract_details="contract_details"
															:document_id="document_id"
															:document="{}"
															:files="files"
													></form-specification>
													</div>
											</div>
									</div>
							</div>
					</div>
			</div>
</template>
<script>
	import FormM from './../form-m'
	import FormPackaging from './../../contracts/form-packaging.vue'
	export default{
		name: "InlineDocumentViewer",
		components: { FormM, FormPackaging },
		data(){
			return {
				document_type: '',
				document_id: '',
				document_parent: '',
				contract_details: {}
			}
		},
		mounted(){
			if(!this.$route.params.type || this.$route.params.type==''){
				// this.$router.go(-1)
				console.log(this.$route.params)
			}else{
				this.document_type = this.$route.params.type
				this.document_id = this.$route.params.id
				this.document_parent = this.$route.params.parent

				this.loadContractDetails()
			}
		},
		methods: {
			/**
				* proceeds back to contract documents tab
				*/
			backToContractDocs(){
				this.$router.push({
					name: 'contracts-single-documents-tab',
					params: {
						id: this.document_parent
					}
				})
			},
			/**
				* loads contract details to fill data into the document vie contract details prop
				*/
			loadContractDetails(){
				axios.get(window.base + '/document/getFirm').then(response=>{
					this.owner_company = response.data.org_name
				})
				
				axios.get(window.base + '/Contract/GetContract?attis_contract_id='+this.document_parent)
				.then(response=>{

					this.contract_details.attis_contract_id=response.data.attis_contract_id
					this.contract_details.attis_contract_owner=response.data.attis_contract_owner
					// this.findLibValue(this.statuses, response.data.attis_contract_status, 'attis_contract_status')
					this.contract_details.attis_contract_type=response.data.attis_contract_type
					this.contract_details.attis_contract_case=response.data.attis_contract_case
					this.contract_details.attis_contract_subject=response.data.attis_contract_subject
					this.contract_details.attis_contract_desc=response.data.attis_contract_desc
					this.contract_details.attis_contract_kpveds=response.data.attis_contract_kpveds
					// this.contract_details.attis_contract_kpveds = '44,482,1422'
					// this.findLibValue('currency', response.data.attis_contract_currency,'attis_contract_currency')
					// this.findLibValue('delivery_term', response.data.attis_contract_delivery_term,'attis_contract_delivery_term')
					this.contract_details.attis_contract_delivery_place=response.data.attis_contract_delivery_place.replace('%2C',',')
					this.contract_details.attis_contract_date=response.data.attis_contract_date
					// this.findLibValue('payment_type', response.data.attis_contract_payment_type, 'attis_contract_payment_type')
					// this.findLibValue('company', response.data.attis_contract_contragent, 'attis_contract_contragent')

					// setTimeout(()=>{
					// 	axios.get(window.base + '/document/getFirmbyBin?bin='+this.contract_details.attis_contract_contragent.value).then(response=>{
					// 		this.counterparty_name = response.data.persons.given_name + ' ' +response.data.persons.middle_name + ' ' + response.data.persons.last_name
					// 	})
					// }, 1000)

					this.contract_details.attis_contract_deadline=response.data.attis_contract_deadline
					this.contract_details.attis_contract_create_date=response.data.attis_contract_create_date
					this.contract_details.attis_contract_is_public=response.data.attis_contract_is_public

					this.attis_contract_goods = response.data.product
					// this.processProducts()
					this.files = response.data.files
				})
			},
			/**
				* finds library value object in array of data by value
				* @param {*} lib 
				* @param {*} value 
				* @param {*} field 
				*/
			findLibValue(lib, value, field){
				if(typeof lib == 'string'){
					axios.get(window.base+'/library?type='+lib+'&query=&qty=1000'+'&lang='+this.$i18n.locale)
					.then(response=>{
						response.data.forEach(item=>{
							if(item.value.trim().toLowerCase()==value.trim().toLowerCase()){
								this.$set(this.attis_contracts,field, item)
							}
						})
					})
				}else{
					lib.forEach(item=>{
						if(item.value == value)
							this.$set(this.attis_contracts, field, item)
					})
				}
			},
			/**
				* process products
				*/
			processProducts(){
				if(typeof this.attis_contract_goods !== 'undefined')
					this.attis_contract_goods.forEach((item, index)=>{
						// this.findTNVED(item.attis_cg_TNVED, index)
						// if (item.attis_cg_measures)
						// 	this.findLibValueProduct('measure', item.attis_cg_measures, 'attis_cg_measures', index)
					})
			},
		}
	}
</script>